(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wmf-house-directory"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-wmf-directory]').forEach((root) => {
    const input = root.querySelector('[data-wmf-house-search]');
    const cards = [...root.querySelectorAll('[data-wmf-house-card]')];
    const empty = root.querySelector('[data-wmf-house-empty]');
    input?.addEventListener('input', () => {
      const term = input.value.trim().toLowerCase();
      let visible = 0;
      cards.forEach((card) => { const match = card.dataset.houseName.toLowerCase().includes(term); card.hidden = !match; if (match) visible += 1; });
      empty.hidden = visible !== 0;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wmf-house-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-wmf-house-sort]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });
  document.querySelectorAll('[data-wmf-filters]').forEach((form) => {
    const toggle = form.querySelector('[data-wmf-filter-toggle]');
    const body = form.querySelector('[data-wmf-filter-body]');
    if (window.matchMedia('(max-width: 899px)').matches) body.hidden = true;
    toggle?.addEventListener('click', () => { body.hidden = !body.hidden; toggle.setAttribute('aria-expanded', String(!body.hidden)); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wmf-luxury-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-wmf-pdp]').forEach((root) => {
    const select = root.querySelector('[data-wmf-variant]');
    const waitlist = root.querySelector('[data-wmf-waitlist]');
    const enquiry = waitlist?.querySelector('form');
    const stoqButton = waitlist?.querySelector('[data-wmf-stoq-button]');
    const title = waitlist?.querySelector('[data-wmf-waitlist-title]');
    const copy = waitlist?.querySelector('[data-wmf-waitlist-copy]');
    let stoqReady = false;
    let attempts = 0;
    const connectStoq = () => {
      if (stoqReady || !stoqButton || typeof window._RestockRocket?.openModal !== 'function') return stoqReady;
      let stoqProduct;
      try { stoqProduct = JSON.parse(root.querySelector('[data-wmf-stoq-product]').textContent); }
      catch (_) { return false; }
      stoqReady = true;
      if (enquiry) enquiry.hidden = true;
      stoqButton.hidden = false;
      if (title) title.textContent = waitlist.dataset.stoqTitle;
      if (copy) copy.textContent = waitlist.dataset.stoqCopy;
      stoqButton.addEventListener('click', () => {
        const variantId = select?.value || root.querySelector('.wmf-pdp__form input[name="id"]')?.value;
        if (!variantId) return;
        try { window._RestockRocket.openModal(stoqProduct, String(variantId)); }
        catch (_) {
          if (enquiry) enquiry.hidden = false;
          stoqButton.hidden = true;
          if (title) title.textContent = enquiryTitle;
          if (copy) copy.textContent = enquiryCopy;
        }
      });
      return true;
    };
    const enquiryTitle = title?.textContent;
    const enquiryCopy = copy?.textContent;
    if (!connectStoq()) {
      const timer = setInterval(() => {
        attempts += 1;
        if (connectStoq() || attempts >= 20) clearInterval(timer);
      }, 500);
    }
    if (!select) return;
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const available = option.dataset.available === 'true';
      root.querySelectorAll('[data-wmf-price], [data-wmf-mobile-price]').forEach((node) => { node.textContent = option.dataset.price; });
      root.querySelector('[data-wmf-availability]').textContent = available ? 'In stock' : 'Temporarily unavailable';
      root.querySelectorAll('[data-wmf-add], [data-wmf-mobile-add]').forEach((button) => {
        button.disabled = !available;
        button.textContent = available ? 'Add to Bag' : 'Unavailable';
      });
      const waitlist = root.querySelector('[data-wmf-waitlist]');
      if (waitlist) waitlist.hidden = available;
      const waitlistVariant = root.querySelector('[data-wmf-waitlist-variant]');
      if (waitlistVariant) waitlistVariant.value = option.textContent.trim();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wmf-partner-invitation"] && !Shopify.designMode) return;
  try {
    
  (()=>{document.querySelectorAll('[data-wmf-partner-invitation]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const query=new URLSearchParams(location.search),token=query.get('token')||'',preview=query.get('wmf_preview')==='1',api=root.dataset.api,loading=root.querySelector('[data-partner-loading]'),unavailable=root.querySelector('[data-partner-unavailable]'),content=root.querySelector('[data-partner-content]'),complete=root.querySelector('[data-partner-complete]'),form=root.querySelector('[data-partner-form]'),errorBox=root.querySelector('[data-form-error]'),button=root.querySelector('[data-submit-button]');const showUnavailable=message=>{loading.hidden=true;content.hidden=true;complete.hidden=true;unavailable.hidden=false;unavailable.querySelector('p').textContent=message||root.dataset.unavailableCopy};const showComplete=status=>{loading.hidden=true;content.hidden=true;unavailable.hidden=true;complete.hidden=false;complete.querySelector('[data-complete-heading]').textContent=status==='onboarding_invited'?'Your Partner House invitation is on its way.':'Your payment is confirmed and under secure review.';complete.querySelector('[data-complete-copy]').textContent=status==='onboarding_invited'?'Check your inbox for the separate, single-use invitation that creates your restricted onboarding account.':'WMF XIII will complete the secure account review and send your onboarding access.'};const render=data=>{loading.hidden=true;unavailable.hidden=true;content.hidden=false;root.querySelector('[data-tier-label]').textContent=data.tierLabel;root.querySelector('[data-tier-audience]').textContent=data.tierAudience;root.querySelector('[data-fee-label]').textContent=data.activationFeeLabel;root.querySelector('[data-fee-includes]').innerHTML=data.feeIncludes.map(item=>`<li>${item.replace(/[&<>"']/g,character=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[character]))}</li>`).join('');const commission=root.querySelector('[data-commission-copy]');commission.innerHTML=data.dropshipCommissionPct===null?'<p>Your commercial commission terms are set in the WMF XIII agreement after review.</p>':`<p><strong>${data.dropshipCommissionPct}%</strong> dropshipping commission when your brand fulfils directly.</p><p><strong>${data.consignmentCommissionPct}%</strong> consignment commission when WMF XIII fulfils.</p>`;form.elements.contactName.value=data.contactName||'';form.elements.email.value=data.email||'';form.elements.organisationName.value=data.organisationName||'';form.elements.website.value=data.website||'';form.elements.fulfilmentPreference.value=data.fulfilmentPreference||'undecided';button.textContent=data.activationFeeCents>0?root.dataset.paidLabel:root.dataset.waivedLabel;if(['onboarding_invited','paid_manual_review'].includes(data.status))showComplete(data.status)};if((root.dataset.editorPreview==='true'||preview)&&!token){render({tierLabel:'Equity Brand',tierAudience:'An invited partnership pathway appears here.',activationFeeLabel:'$113',activationFeeCents:11300,feeIncludes:['Full onboarding','Catalogue integration','Photography refinement','Brand-story curation','First-month marketing support'],dropshipCommissionPct:25,consignmentCommissionPct:35,contactName:'',email:'invited@brand.ca',organisationName:'Invited Brand',website:'',fulfilmentPreference:'undecided',status:'viewed'});return}if(!token){showUnavailable(root.dataset.unavailableCopy);return}fetch(`${api}?token=${encodeURIComponent(token)}`).then(async response=>{const data=await response.json();if(!response.ok)throw new Error(data.error);render(data)}).catch(reason=>showUnavailable(reason.message));form.addEventListener('submit',async event=>{event.preventDefault();button.disabled=true;button.textContent=root.dataset.processingCopy;errorBox.hidden=true;const fields=new FormData(form);try{const response=await fetch(api,{method:'POST',headers:{'content-type':'application/json'},body:JSON.stringify({token,contactName:fields.get('contactName'),organisationName:fields.get('organisationName'),website:fields.get('website'),fulfilmentPreference:fields.get('fulfilmentPreference'),termsAccepted:fields.get('termsAccepted')==='on',marketingConsent:fields.get('marketingConsent')==='on'})}),result=await response.json();if(!response.ok)throw new Error(result.error);if(result.checkoutUrl){location.assign(result.checkoutUrl);return}showComplete(result.status)}catch(reason){errorBox.textContent=reason.message||root.dataset.submitError;errorBox.hidden=false;button.disabled=false;button.textContent=root.dataset.paidLabel}})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wmf-seo-foundation"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-wmf-event]');
    if (!target) return;
    window.dispatchEvent(new CustomEvent('wmf:commerce-event', { detail: { name: target.dataset.wmfEvent, label: target.dataset.wmfLabel || '' } }));
  });

  } catch(e) { console.error(e); }
})();
})();
